// src/modules/expert/corporative-contacts/routes.ts
import type { RouteRecordRaw } from 'vue-router'

export const corporativeContactsRoutes: RouteRecordRaw[] = [
  {
    path: ':id/contacts/corporative',
    name: 'corporative-contacts-list',
    component: () =>
      import('@/modules/expert/corporative-contacts/views/CorporativeList.vue'),
  },
  {
    path: ':id/contacts/corporative/new',
    name: 'corporative-create-general-data',
    component: () =>
      import(
        '@/modules/expert/corporative-contacts/views/CorporativeEditGeneralData.vue'
      ),
  },
  {
    path: ':id/contacts/corporative/:contactId/edit',
    name: 'corporative-edit-general-data',
    component: () =>
      import(
        '@/modules/expert/corporative-contacts/views/CorporativeEditGeneralData.vue'
      ),
  },
  {
    path: ':id/contacts/corporative/:contactId/edit-relationships',
    name: 'corporative-edit-relationships',
    component: () =>
      import(
        '@/modules/expert/corporative-contacts/views/CorporativeEditRelationships.vue'
      ),
  },
  {
    path: ':id/contacts/corporative/:contactId/detail',
    name: 'corporative-detail',
    component: () =>
      import(
        '@/modules/expert/corporative-contacts/views/CorporativeDetail.vue'
      ),
  },
]
